export const SEARCH_MENU_PRODUCTS =
  'app/conversion/menuSearch/SEARCH_MENU_PRODUCTS';

export const CLEAN_SEARCH = 'app/conversion/menuSearch/CLEAN_SEARCH';

export const FILTER_SECTION_ITEMS =
  'app/conversion/menuSearch/FILTER_SECTION_ITEMS';
